import { render, staticRenderFns } from "./LmTermsIcon.vue?vue&type=template&id=3f9f5676"
import script from "./LmTermsIcon.vue?vue&type=script&lang=js"
export * from "./LmTermsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports